import Abstract from "../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../render/render.js";

import {
  CATALOG_PAGE_HREF
} from "../const.js";

import {
  EMPTY_TEXT,
  EMPTY_LINK_TEXT
} from "../lexicon.js";

const createEmptySectionTemplate = () => {
  return (
    `<section class="favorites-empty-section">
      <div class="content">
        <p>${EMPTY_TEXT} <a href="${CATALOG_PAGE_HREF}">${EMPTY_LINK_TEXT}</a>.
      </div>
    </section>`
  );
};

export default class EmptySection extends Abstract {
  constructor() {
    super();
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  _getTemplate() {
    return createEmptySectionTemplate();
  }
}
